import styles from "./App.module.css";
import mobile from "./shared/mobile";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppFrame } from "@wwg/ui";
import { IconArchive, IconBook, IconContact } from "@wwg/icons";
import { AddContactButton } from "./shared/components/AddContactButton/AddContactButton";
import { IconContacts } from "./shared/icons/IconContacts";
import { Contacts } from "./Contacts/Contacts";
import { ManageBSM } from "./ManageBSM/ManageBSM";
import { Archive } from "./Archive/Archive";
import { ToastContainer } from "react-toastify";
import env from "./environment";
import { useEffect } from "react";
import { makeAuthedRequest } from "shared/utils/makeAuthedRequest";
import useAnalytics from "shared/hooks/useAnalytics";

export function App() {
  const { t } = useTranslation();
  const history = useHistory();

  // redirect if verification needed
  useEffect(() => {
    if (env.localDevMode) return;

    var url = env.coreApiUrl + "verification/redirect";

    makeAuthedRequest(url, {
      method: "post",
      body: JSON.stringify({ currentAppUrl: window.location.href }),
    })
      .then(async (res) => {
        const json = await res.json();

        if (res.ok && json.shouldRedirect && json.redirectUrl) {
          document.cookie =
            "returnUrl=" +
            window.location.href +
            ";path=/;domain=" +
            env.rootDomain;

          window.location.assign(json.redirectUrl);
        }
      })
      .catch();
  }, []);

  useAnalytics();

  return (
    <AppFrame
      mobileBridge={mobile}
      header={{
        title: t("nav.contacts"),
        icon: <IconContacts width={32} height={32} />,
        controls: [
          <AddContactButton
            onClick={() => {
              history.push("/contacts/new");
            }}
          />,
        ],
      }}
      navigation={[
        {
          title: t("nav.contacts"),
          icon: <IconContact />,
          path: "/contacts",
        },
        {
          title: t("nav.manageBSMs"),
          icon: <IconBook />,
          path: "/bsm",
        },
        {
          title: t("nav.archive"),
          icon: <IconArchive />,
          path: "/archive",
        },
      ]}
      maxHeaderWidth={1500}
    >
      <main className={styles.main}>
        <Switch>
          <Route path="/contacts/:type?/:id?">
            <Contacts />
          </Route>

          <Route path="/bsm">
            <ManageBSM />
          </Route>

          <Route path="/archive/:type?/:id?">
            <Archive />
          </Route>

          <Route path="*">
            <Redirect to="/contacts" />
          </Route>
        </Switch>
      </main>

      <ToastContainer />
    </AppFrame>
  );
}
